import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ICreateSADisciplineRequest } from 'Data/interfaces/Obra/ISolutionSADisciplineRequest';

export const useQueryCreateDisciplineSA = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: ICreateSADisciplineRequest) => {
      return ObrasApi.createSADiscipline(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(data.data.ConstructionSiteFk)],
        }),
      ]);

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY],
        (old) => {
          return old?.map((obra) => {
            if (
              obra.ConstructionSiteId === variables.ConstructionSiteId &&
              obra.Disciplines && obra.Disciplines.length > 0
            ) {
              const index = obra.Disciplines.findIndex((discipline: any) => {
                return discipline.ConstructionSiteDisciplinesId === data.data.ConstructionSiteDisciplinesId;
              });
              if (index !== -1) {
                obra.Disciplines[index] = data.data;
              }
            }
            return obra;
          });
        },
      );
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(data.data.ConstructionSiteFk)],
        (old) => {
          if (old && old.Disciplines && old.Disciplines.length > 0) {
            const index = old.Disciplines.findIndex((discipline: any) => {
              return discipline.ConstructionSiteDisciplinesId === data.data.ConstructionSiteDisciplinesId;
            });
            if (index !== -1) {
              old.Disciplines[index] = data.data;
            }
          }
          return old;
        },
      );

      // TODO: invalidar chave da listagem de arquivos para essa disciplina
    },
    onError: async (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao criar disciplina';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    createDisciplineSA: mutate,
    isLoading: isPending,
  };
};
